import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import type { ComputedEventSchedule, EventDetailsResponse, Event, Business } from '@/features/events/types/types';

interface UseEventNavigationReturn {
    handleBookTable: (schedule: ComputedEventSchedule) => void;
    handleBookTickets: (schedule: ComputedEventSchedule) => void;
    eventInfo: Event | null;
    businessInfo: Business | null;
    clubHandle: string | null;
}

export const useEventNavigation = (
    eventDetails: EventDetailsResponse | null,
    eventId: string | undefined,
    handle?: string
): UseEventNavigationReturn => {
    const navigate = useNavigate();

    const eventInfo = useMemo(() => {
        return eventDetails?.data?.event || null;
    }, [eventDetails]);

    const businessInfo = useMemo(() => {
        return eventDetails?.data?.event?.business || null;
    }, [eventDetails]);

    // Extract club handle for hamburger menu
    const clubHandle = useMemo(() => {
        return handle || businessInfo?.handle || null;
    }, [handle, businessInfo]);

    const handleBookTable = useCallback((schedule: ComputedEventSchedule) => {
        // Navigate to table booking category page
        navigate(`/venues/${businessInfo?.handle}/events/${eventId}/booking/${schedule.id}?type=tables`);
    }, [navigate, businessInfo, eventId]);

    const handleBookTickets = useCallback((schedule: ComputedEventSchedule) => {
        // Navigate to ticket booking category page
        navigate(`/venues/${businessInfo?.handle}/events/${eventId}/booking/${schedule.id}?type=tickets`);
    }, [navigate, businessInfo, eventId]);

    return {
        handleBookTable,
        handleBookTickets,
        eventInfo,
        businessInfo,
        clubHandle
    };
};
